import { path } from "ramda";
export var selectProjectLastModified = function selectProjectLastModified(projectUid) {
    return function (store) {
        return path(["ProjectLastModifiedReducer", projectUid], store);
    };
};
